<template>
  <div v-if="visible && feedbacks && feedbacks.length !== 0" id="carousel-feedbacks">
    <el-carousel
      height="90px"
      :autoplay="false"
      indicator-position="none"
      :arrow="feedbacks.length > 1 ? 'always' : 'never'"
      @change="onChangeHandler($event)"
    >
      <el-carousel-item
        v-for="(feedback, index) in feedbacks"
        :key="index"
      >
        <div class="carousel-container">
          <div class="carousel-company">
            <div class="company-info">
              <div
                class="company-logo"
                :style="{ backgroundImage: `url('${(feedback.customer.logo ? feedback.customer.logo : null)}')` }"
              />
              <div class="company-content">
                <div class="fullname">
                  {{ feedback.customer_user.firstname }} {{ feedback.customer_user.lastname }}
                </div>
                <div class="company-and-date">
                  {{ feedback.customer.name }}, {{ formatFromNow(feedback.createdAt.date) }}
                </div>
              </div>
            </div>

            <div class="rating-container">
              <div class="notation">
                <el-rate
                  v-model="feedback.score"
                  disabled
                  :colors="['#ffd859','#ffd859','#ffd859']"
                />
              </div>
              <el-tooltip
                v-if="feedback.soft_skills && feedback.soft_skills.length !== 0"
                effect="dark"
                :content="getSoftSkillsNames(feedback.soft_skills)"
                placement="top"
                :show-arrow="false"
              >
                <div class="softskills item">
                  <span
                    v-for="(softskill, index) in feedback.soft_skills.slice(0, 2)"
                    :key="index"
                    class="sub-icon-text"
                  >{{ softskill.name }}</span>
                  <span v-if="feedback.soft_skills[2]" class="sub-icon-text"> + {{ feedback.soft_skills.length - 2 }} <i class="fa fa-info-circle"/></span>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>

import moment from 'moment';

export default {
  props: ['visible', 'feedbacks'],
  data() {
    return {
      nextOrPrev: false,
    };
  },
  methods: {
    formatFromNow(date) {
      return moment(date)
        .fromNow();
    },

    onChangeHandler(e) {
      this.mxTrack(e);
    },
    mxTrack(e) {
      if (e !== 0) {
        if (this.feedbacks.length > 1 && !this.nextOrPrev) {
          this.$mixpanel.track('Student Comment Slider Displayed');
          this.nextOrPrev = true;
        }
      }
    },
    getSoftSkillsNames(softSkills) {
      return softSkills.reduce((acc, softSkill) => {
        acc.push(softSkill.name);
        return acc;
      }, []).join(', ');
    },
  },
};
</script>
